module.exports = __webpack_public_path__ + "static/media/user.76dfe7f4.jpg";